<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">Zavolejte hypotečnímu specialistovi</div>
    </div>

    <div class="hypo-dialog-content" [attr.data-testid]="'invalid-modelations-dialog'">
        @if (mortgage.lastContactedAt) {
            <p>
                Řešení, které zde vidíte, je z {{ mortgage.lastContactedAt | date }}, kdy jsme si naposledy
                telefonovali. Chcete vidět dnešní možnosti? Zavolejte mi, prosím.
            </p>
        }
        @if (!mortgage.lastContactedAt) {
            <p>
                Řešení, které zde vidíte, je z data, kdy jsme si naposledy telefonovali. Chcete vidět dnešní možnosti?
                Zavolejte mi, prosím.
            </p>
        }

        <app-contact-specialist [owner]="mortgage._owner"> </app-contact-specialist>
    </div>

    <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-center">
        <button
            (click)="dialogRef.close()"
            class="btn btn-lg orange info-text-dialog-button"
            [attr.data-testid]="'invalid-modelations-dialog-button-close'"
            mat-button
            type="button">
            Zavřít
        </button>
    </div>
</mat-dialog-content>
